<template>
  <ErrorLayout>
    <p>パスワードの有効期限が切れています。</p>
    <p>新しいダミーIDとパスワードを発行して、再度ログインしてください。</p>
  </ErrorLayout>
</template>

<script>
import ErrorLayout from '@/views/pages/ErrorLayout/index.vue';

export default {
  components: {
    ErrorLayout,
  },
  data() {
    return {};
  },
};
</script>
  
<style lang="scss"></style>
